import { FormFieldHelp } from "@/features/post/components/forms/FormFieldHelp";
import { cn } from "@/shared/lib";

export interface DesktopFormFieldProps {
  label: string;
  labelId: string;
  fieldClassName: string;
  contentClassName?: string;
  /**
   * trueの場合、内容ラッパーに role="group" と aria-labelledby を付与し、
   * 個々のコントロールが自前でラベル関連付けを持たない場合でも
   * フィールド全体をプログラム的にラベルと関連付ける（添付Fileフィールド用）。
   * コメントフィールドのようにコントロール自身が aria-labelledby を持つ場合は不要。
   */
  groupContent?: boolean;
  /** ラベル横のヘルプアイコンから表示する説明 */
  helpText?: string;
  children: React.ReactNode;
}

/**
 * PC版グリッド（ラベル左・入力右）で、見出しと実入力欄を隣接させて描画する。
 * `.desktop-floating-field` は2カラムグリッドのため、
 * 内容側は常に単一の div で包み、グリッドセルが1要素になるようにする
 * （UpfileInput のように複数のトップレベル要素を返すコンポーネントでも折り返さない）。
 */
export const DesktopFormField: React.FunctionComponent<
  DesktopFormFieldProps
> = ({
  label,
  labelId,
  fieldClassName,
  contentClassName,
  groupContent = false,
  helpText,
  children,
}: DesktopFormFieldProps) => (
  <fieldset
    aria-labelledby={labelId}
    className={cn(
      "desktop-floating-field m-0 min-w-0 border-0 p-0",
      fieldClassName,
    )}
  >
    <p className="desktop-floating-label">
      <b id={labelId}>{label}</b>
      {helpText && <FormFieldHelp label={label} helpText={helpText} />}
    </p>
    <div
      className={cn("desktop-floating-field-content", contentClassName)}
      {...(groupContent
        ? { role: "group" as const, "aria-labelledby": labelId }
        : undefined)}
    >
      {children}
    </div>
  </fieldset>
);
